import { render, staticRenderFns } from "./ModalOptionsToggleButton.vue?vue&type=template&id=495e63a8&"
import script from "./ModalOptionsToggleButton.vue?vue&type=script&lang=js&"
export * from "./ModalOptionsToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports